import { Controller } from "stimulus"

export default class extends Controller {
  static get targets() {
    return [
      // mobileNav is the mobile nav section that defaults to being hidden.
      "mobileNav",

      // open is the "open" SVG icon.
      "open",

      // close is the "close" SVG icon.
      "close"
    ]
  }

  /**
   * connect sets the default "closed" state of the mobile nav by setting the
   * navbar controller's data-open value to an empty string.
   */
  connect = () => {
    this.element.dataset.open = ""
  }

  toggle = () => {
    if (this.element.dataset.open !== "true") {
      this.mobileNavTarget.classList.remove("hidden")
      this.mobileNavTarget.classList.add("block")

      this.openTarget.classList.remove("block")
      this.openTarget.classList.add("hidden")

      this.closeTarget.classList.remove("hidden")
      this.closeTarget.classList.add("block")

      this.element.dataset.open = "true"
    } else {
      this.mobileNavTarget.classList.remove("block")
      this.mobileNavTarget.classList.add("hidden")

      this.openTarget.classList.remove("hidden")
      this.openTarget.classList.add("block")

      this.closeTarget.classList.remove("block")
      this.closeTarget.classList.add("hidden")

      this.element.dataset.open = ""
    }
  }
}
